<template>
  <main class="view news">
    <TeaserBig
      v-for="(item, idx) in items"
      :key="`news-teaser-${idx}`"
      :stagger="idx + 1"
      :item="item"
      slug-path="/news"
      :visible="allLoaded"
      @loaded="handleLoaded"
    />
  </main>
</template>

<script>
  import TeaserBig from '@/components/ui/TeaserBig';

  export default {
    name: 'News',
    components: {
      TeaserBig,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        items: [],
        numLoaded: 0,
        allLoaded: false,
      };
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    mounted() {
      const items = this.$b.data?.entries || [];
      items.sort((a, b) => a.id - b.id);
      this.items = items.filter(i => i.published === true).reverse();
    },
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      handleLoaded() {
        this.numLoaded += 1;
        if (this.numLoaded >= this.items.length) {
          this.allLoaded = true;
        }
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.view.news {
  @include max-width-constraints;
  width: 100%;

  @include screen-tablet-landscape {
    overflow: hidden;
    width: 100%;
    padding: 0 15px;
  }
}
</style>
